module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewShow),
      expression: "viewShow"
    }],
    staticClass: "link"
  }, [_c('div', {
    staticClass: "main_view"
  }, [(_vm.linkType == 1) ? _c('div', [_c('p', {
    staticClass: "t1-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "t1-desc"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "refuse",
    on: {
      "click": _vm.onRefuseClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cancelBtn))])]), _vm._v(" "), _c('div', {
    staticClass: "accept",
    on: {
      "click": _vm.onAcceptClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.sureBtn))])])])]) : _vm._e(), _vm._v(" "), (_vm.linkType == 2) ? _c('div', [_c('p', {
    staticClass: "t2-desc"
  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
    staticClass: "footer t2-footer"
  }, [_c('div', {
    staticClass: "t2-refuse",
    on: {
      "click": _vm.onRefuseClicked
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/refuse_lianmai.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "t2-accept",
    on: {
      "click": _vm.onAcceptClicked
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/accpet_lianmai.png"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.linkType == 3) ? _c('div', [_c('p', {
    staticClass: "t1-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "refuse",
    on: {
      "click": _vm.onRefuseClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cancelBtn))])]), _vm._v(" "), _c('div', {
    staticClass: "accept",
    on: {
      "click": _vm.onAcceptClicked
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.sureBtn))])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38350a1d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/LinkPopup.vue
// module id = 376
// module chunks = 0